import { Component, ElementRef, EventEmitter, Input, NgZone, OnChanges, OnInit, Output, SimpleChanges, ViewChild, computed, effect, signal, viewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BehaviorSubject, Subscription } from 'rxjs';
import {  FormField, ModelForFormContainer } from 'src/app/shared/forms/abstract-form-field.directive';
import { FormContainerVM, FormFieldValue, FormVMContainerDirective } from 'src/app/shared/forms/form-vm-container.directive';

@Component({
  selector: 'app-radio-button:not([multipleRadiosDir])',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss']
})
export class RadioButtonComponent extends FormField<string>  {

  ele = viewChild<ElementRef<HTMLInputElement>>('nativeEle')
  nativeInputChecked(){
    return this.ele()?.nativeElement.checked
  }


  // não funciona: checked muda independente do signal ele(),
  // como esse é lazy calc, vai ficar com o ultimo valor
  // nativeInputChecked = computed(() => {
  //   return this.ele()?.nativeElement.checked
  // })

  // @Input() control: FormControl= new FormControl();

  _checked : boolean = false;
  get checked() {
    return this._checked;
  }

  internalControl : FormControl = new FormControl();

  @Input() label?: string;
  @Input() bold: string = '';

  @Input() id: string = '';
  @Input() items: string[] = [];
  itemsChecked: boolean[] = []

  // se esse componente é filho de outro RadioButtonComponent,
  // usado para saber se usa ou não o control fornecido por input
  @Input() recursiveChild = false

  @Input() override value: string = '';
  @Input() multipleRadios: boolean = false;
  @Input() fontSize: number = 12;
  @Input() orientation: 'vertical' | 'horizontal' = 'horizontal'
  readonly type = 'radio'
  @Input() styleWidth100 = false; // controla se comp vai ocupar todo width disponivel (todo: mudar para nome melhor)
  @Input() required = false;
  @Input() valid = false;
  @Input() gap: string='';
  @Input() selfChecked = false;

  @Input() valueBiding: string = '';
  @Output() select = new EventEmitter<string>()


  readonly fieldType = 'radio';


  controlSubscription?: Subscription

  static uuid = 0;

  instanceUuid = 0;

  constructor(public zone: NgZone) {
    super()
    this.instanceUuid =  RadioButtonComponent.uuid;
    RadioButtonComponent.uuid += 1;

    // console.log(this.instanceUuid)
  }

  log() {
    // this.model = this.value
  }

  override ngOnInit(): void {
    super.ngOnInit()

  }


  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    // if (changes['valueBiding']) {
    //   this.itemsChecked = this.items.map(item => item === this.valueBiding)
    //   this.control.patchValue(changes['valueBiding'].currentValue, { emitEvent: false })
    // }
    if(changes['gap']){
      this.gap=changes['gap'].currentValue
    }
  }

  modelTest : any;

  test?: any;



  onChang2(event: Event) {
    const domEle = event.target as HTMLInputElement
    this._checked = domEle.checked;

    if (this._checked) {
      this.model = this.value;
      this.select.emit(this.value)
    } else {
      this.model = undefined
    }

  }

  changeEf = effect( () => {
    this.onChange(this.model ?? '')
  })

  onChange(checked: string) {

    // if (checked) {
    //   this.model = this.value;
    this.select.emit(this.value)
      // this.model = checked
    // } else {
    //   this.model = undefined;
    // }

  }

  updateModel(formVM: FormContainerVM, value: FormFieldValue): FormContainerVM {
    return {
      ...formVM,
      [this.name] : value
    }
  }


  _multipleSelectHandler(event: string) {
    this.model = event;
    this.select.emit(event)
  }


}
